/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout'
import LayoutView from '@/layout/layout'

const accountRouter = {
	path: '/accountCenter',
	component: Layout,
	redirect: 'accountino',
	name: '账户',
	id: 800000,
	meta: {
		title: '账户',
		icon: 'account',
		roles: [800000]
	},
	children: [{
		path: 'account',
		component: LayoutView,
		name: '账户管理',
		redirect: 'account',
		id: 810000,
		meta: { title: '账户管理', roles: [810000] },
		children: [
			{
				path: 'accountmanager',
				component: () =>
					import('@/leniuview/accountCenter/account-manager'),
				name: 'account-manager',
				id: 810100,
				meta: { title: '账户管理', roles: [810100], noCache: true }
			},
			{
				path: 'baseset',
				component: () =>
					import('@/leniuview/accountCenter/account-manager/baseset'),
				name: 'baseset',
				id: 810200,
				meta: { title: '基础设置', roles: [810200], noCache: true }
			},
			{
				path: 'expired',
				component: () =>
					import('@/leniuview/accountCenter/account-manager/expired'),
				name: 'account-manager-expired',
				meta: { title: '过期列表', roles: [810200], noCache: true },
				hidden: true
			},
			{
				path: 'logoff',
				component: () =>
					import('@/leniuview/accountCenter/account-manager/logoff'),
				name: 'account-manager-logoff',
				meta: { title: '注销列表', roles: [810200], noCache: true },
				hidden: true
			},
			{
				path: 'traderecords',
				component: () =>
					import('@/leniuview/accountCenter/account-manager/trade-records'),
				name: 'trade-records',
				id: 810300,
				meta: { title: '账户操作记录', roles: [810300], noCache: true }
			},
			{
				path: 'old-sys-import',
				component: () =>
					import('@/leniuview/accountCenter/account-manager/old-sys-import'),
				name: 'old-sys-import',
				id: 810400,
				meta: { title: '老系统导入', roles: [810400], noCache: true }
			}
		]
	},
	{
		path: 'consume',
		component: LayoutView,
		name: '账户消费',
		id: 820000,
		meta: { title: '账户消费', roles: [820000] },
		redirect: 'deduct',
		children: [
			{
				path: 'deduct',
				component: () => import('@/leniuview/accountCenter/deduct'),
				name: '消费补扣',
				id: 820100,
				meta: { title: '消费补扣', noCache: true, roles: [820100] }
			},
			{
				path: 'deductErrorList',
				component: () =>
					import(
						/* webpackChunkName: "deductErrorList" */ '@/leniuview/accountCenter/deduct/deductErrorList'
					),
				name: '批量补扣异常信息列表',
				meta: { title: 'account.plbukouyichang', roles: [820100] },
				hidden: true
			},
			{
				path: 'deductImport',
				component: () =>
					import(
						/* webpackChunkName: "deductImport" */ '@/leniuview/accountCenter/deduct/deductImport'
					),
				name: '导入补扣',
				meta: { title: '导入补扣', roles: [820100] },
				hidden: true
			},
			{
				path: 'trade',
				component: () => import('@/leniuview/accountCenter/deduct/trade'),
				name: '消费明细',
				id: 820200,
				meta: { title: '消费明细', roles: [820200] }
			},
			{
				path: 'consumeSummary',
				component: () =>
					import('@/leniuview/accountCenter/deduct/consumeSummary'),
				redirect: 'consumeSummary/psntype',
				name: '消费汇总',
				id: 820300,
				meta: { title: '消费汇总', roles: [820300] },
				children: [
					// {
					//   path: "canteen",
					//   component: () =>
					//     import("@/leniuview/accountCenter/deduct/canteen"),
					//   name: "食堂消费汇总",
					//   meta: { title: "食堂消费汇总", roles: [820300], noCache: true },
					//   hidden: true,
					// },
					{
						path: 'psntype',
						component: () =>
							import('@/leniuview/accountCenter/deduct/psntype'),
						name: '人员类别汇总',
						meta: { title: '人员类别汇总', roles: [820300], noCache: true },
						hidden: true
					},
					{
						path: 'org',
						component: () => import('@/leniuview/accountCenter/deduct/org'),
						name: '组织消费汇总',
						meta: { title: '组织消费汇总', roles: [820300], noCache: true },
						hidden: true
					}
					// {
					//   path: "coremode",
					//   component: () =>
					//     import("@/leniuview/accountCenter/deduct/coremode"),
					//   name: "核身方式消费汇总",
					//   meta: { title: "核身方式消费汇总", roles: [820300], noCache: true },
					//   hidden: true,
					// },
				]
			}
		]
	},
	{
		path: 'recharge',
		component: LayoutView,
		name: '充值提现',
		redirect: 'rechargewithdrawal',
		id: 830000,
		meta: { title: '充值提现', roles: [830000] },
		children: [
			{
				path: 'rechargewithdrawal',
				component: () =>
					import('@/leniuview/accountCenter/recharge-withdrawal'),
				name: 'recharge-withdrawal',
				id: 830100,
				meta: { title: '充值提现', noCache: true, roles: [830100] }
			},
			{
				path: 'rechargeImport',
				component: () =>
					import('@/leniuview/accountCenter/recharge-withdrawal/rechargeImport'),
				name: 'rechargeImport',
				hidden: true,
				meta: { title: '充值导入', noCache: true, roles: [830100] }
			},
			{
				path: 'withdrawalApply',
				component: () =>
					import('@/leniuview/accountCenter/recharge-withdrawal/withdrawalApply'),
				name: '提现申请',
				id: 830200,
				meta: { title: '提现申请', roles: [830200] }
			},
			{
				path: 'withdrawalApproval',
				component: () =>
					import('@/leniuview/accountCenter/recharge-withdrawal/withdrawalApproval'),
				name: '审批记录',
				id: 830300,
				meta: { title: '审批记录', roles: [830300] }
			},
			{
				path: 'rechargeDetail',
				component: () =>
					import(
						/* webpackChunkName: "jilu" */ '@/leniuview/accountCenter/recharge-withdrawal/rechargeDetail'
					),
				name: '充值明细',
				id: 830400,
				meta: { title: '充值明细', roles: [830400] }
			},
			{
				path: 'withdrawDetail',
				component: () =>
					import(
						/* webpackChunkName: "withdrawalRecord" */ '@/leniuview/accountCenter/recharge-withdrawal/withdrawDetail'
					),
				name: '提现明细',
				id: 830500,
				meta: { title: '提现明细', roles: [830500] }
			},
			{
				path: 'rechargeSummary',
				component: () =>
					import('@/leniuview/accountCenter/recharge-withdrawal/rechargeSummary'),
				redirect: 'rechargeSummary/rechargeChannel',
				name: '充值汇总',
				id: 830600,
				meta: { title: '充值汇总', roles: [830600] },
				children: [
					{
						path: 'rechargeChannel',
						component: () =>
							import('@/leniuview/accountCenter/recharge-withdrawal/rechargeChannel'),
						name: '充值渠道汇总',
						meta: { title: '充值渠道汇总', roles: [830600], noCache: true },
						hidden: true
					},
					{
						path: 'psntype',
						component: () =>
							import('@/leniuview/accountCenter/recharge-withdrawal/psntype'),
						name: '人员类别充值汇总',
						meta: { title: '人员类别充值汇总', roles: [830600], noCache: true },
						hidden: true
					},
					{
						path: 'org',
						component: () => import('@/leniuview/accountCenter/recharge-withdrawal/org'),
						name: '组织充值汇总',
						meta: { title: '组织充值汇总', roles: [830600], noCache: true },
						hidden: true
					},
					{
						path: 'rechargeSource',
						component: () => import('@/leniuview/accountCenter/recharge-withdrawal/rechargeSource'),
						name: '充值来源汇总',
						meta: { title: '充值来源汇总', roles: [830600], noCache: true },
						hidden: true
					}
				]
			},
			{
				path: 'withdrawSummary',
				component: () =>
					import('@/leniuview/accountCenter/recharge-withdrawal/withdrawSummary'),
				redirect: 'withdrawSummary/withdrawType',
				name: '提现汇总',
				id: 830700,
				meta: { title: '提现汇总', roles: [830700] },
				children: [
					{
						path: 'withdrawType',
						component: () =>
							import('@/leniuview/accountCenter/recharge-withdrawal/withdrawType'),
						name: '提现方式汇总',
						meta: { title: '提现方式汇总', roles: [830700], noCache: true },
						hidden: true
					},
					{
						path: 'psntype',
						component: () =>
							import('@/leniuview/accountCenter/recharge-withdrawal/withdrawpsntype'),
						name: '人员类别提现汇总',
						meta: { title: '人员类别提现汇总', roles: [830700], noCache: true },
						hidden: true
					},
					{
						path: 'org',
						component: () => import('@/leniuview/accountCenter/recharge-withdrawal/withdraworg'),
						name: '组织提现汇总',
						meta: { title: '组织提现汇总', roles: [830700], noCache: true },
						hidden: true
					}
				]
			}
		]
	},
	{
		path: '',
		component: LayoutView,
		name: '转账冻结',
		id: 840000,
		meta: { title: '转账冻结', roles: [840000] },
		redirect: 'freeze-account',
		children: [
			{
				path: 'freeze',
				component: () =>
					import('@/leniuview/accountCenter/transfer-frozen'),
				name: 'account-manager',
				id: 840100,
				meta: { title: '冻结解冻', noCache: true, roles: [840100] }
			},
			{
				path: 'freezeRule',
				component: () => import('@/leniuview/accountCenter/transfer-frozen/freezeRule'),
				name: '定时规则',
				id: 840200,
				meta: { title: '定时规则', roles: [840200] }
			},
			{
				path: 'transfer',
				component: () => import('@/leniuview/accountCenter/transfer-frozen/transfer'),
				name: '转入转出',
				id: 840300,
				meta: { title: '转入转出', roles: [840300] }
			},
			{
				path: 'transferDetail',
				component: () => import('@/leniuview/accountCenter/transfer-frozen/transferDetail'),
				name: '转账记录',
				id: 840400,
				meta: { title: '转账记录', roles: [840400], noCache: true }
			},
			{
				path: 'freeze-account',
				component: () =>
					import('@/leniuview/accountCenter/transfer-frozen/freeze-account'),
				name: 'account-manager',
				id: 840500,
				meta: { title: '冻结明细', noCache: true, roles: [840500] }
			},
			{
				path: 'unfreeze-account',
				component: () =>
					import(
						'@/leniuview/accountCenter/transfer-frozen/unfreeze-account'
					),
				name: 'account-manager',
				id: 840600,
				meta: { title: '解冻明细', noCache: true, roles: [840600] }
			}
		]
	},
	{
		path: 'butie',
		component: LayoutView,
		name: '补贴管理',
		redirect: 'butie',
		id: 850000,
		meta: { title: '补贴管理', roles: [850000] },
		children: [{
			path: 'butie',
			component: () =>
				import(
					/* webpackChunkName: "butie" */ '@/leniuview/accountCenter/butie/butieChongzhi'
				),
			name: '个人补贴',
			id: 850100,
			meta: { title: '个人补贴', roles: [850100], noCache: true }
		},
		{
			path: 'SubsidiesEmpty',
			component: () =>
				import(
					/* webpackChunkName: "butie" */ '@/leniuview/accountCenter/butie/SubsidiesEmpty'
				),
			name: '补贴清空',
			id: 850200,
			meta: { title: '补贴清空', roles: [850200], noCache: true }
		},
		{
			path: 'butieNew',
			component: () =>
				import(
					/* webpackChunkName: "butieNew" */ '@/leniuview/accountCenter/butie/butieNew'
				),
			name: '补贴规则',
			id: 850300,
			meta: { title: '补贴规则', roles: [850300] }
		},
		{
			path: 'butieHistory',
			component: () =>
				import('@/leniuview/accountCenter/butie/butieHistory'),
			name: '补贴记录',
			id: 850400,
			meta: { title: '补贴记录', roles: [850400] }
		},
		{
			path: 'butieClearHistory',
			component: () =>
				import('@/leniuview/accountCenter/butie/butieClearHistory'),
			name: '补贴清空记录',
			id: 850500,
			meta: { title: '补贴清空记录', roles: [850500] }
		},
		{
			path: 'ruleDetail',
			component: () =>
				import(
					/* webpackChunkName: "ruleDetail" */ '@/leniuview/accountCenter/ruleDetail'
				),
			name: 'ruleDetail',
			meta: { title: '规则详情', roles: [850300], noCache: true },
			hidden: true
		},
		{
			path: 'export',
			component: () =>
				import(
					/* webpackChunkName: "export" */ '@/leniuview/accountCenter/exportButie'
				),
			name: '补贴充值导入',
			meta: { title: '补贴充值导入', roles: [850100] },
			hidden: true
		},
		// {
		//   path: "history",
		//   component: () =>
		//     import(
		//       /* webpackChunkName: "history" */ "@/leniuview/accountCenter/butieHistory"
		//     ),
		//   name: "补贴生效记录",
		//   id: 810203,
		//   meta: { title: "补贴生效记录", roles: [810203] },
		// },
		{
			path: 'butieSummary',
			component: () =>
				import('@/leniuview/accountCenter/butie/butieSummary'),
			redirect: 'butieSummary/butiePersonalType',
			name: '补贴汇总',
			id: 850600,
			meta: { title: '补贴汇总', roles: [850600] },
			children: [
				// {
				//   path: "org",
				//   component: () => import("@/leniuview/accountCenter/recharge-withdrawal/withdraworg"),
				//   name: "组织提现汇总",
				//   meta: { title: "组织提现汇总", roles: [810500] },
				//   hidden: true,
				// }
				{
					path: 'butiePersonalType',
					component: () =>
						import('@/leniuview/accountCenter/butie/butiePersonalType'),
					name: '人员类别补贴汇总',
					meta: { title: '人员类别补贴汇总', roles: [850600] },
					hidden: true
				},
				{
					path: 'butieZuzhi',
					component: () =>
						import('@/leniuview/accountCenter/butie/butieZuzhi'),
					name: '组织补贴汇总',
					meta: { title: '组织补贴汇总', roles: [850600] },
					hidden: true
				}
			]
		},
		{
			path: 'chongzhijieguo',
			component: () =>
				import(
					/* webpackChunkName: "chongzhijieguo" */ '@/leniuview/accountCenter/chongzhijieguo'
				),
			name: '批量充值结果',
			meta: { title: '批量充值结果', roles: [850000] },
			hidden: true
		}
		]
	},
	{
		path: '',
		component: LayoutView,
		name: '红包管理',
		id: 860000,
		meta: { title: '红包管理', roles: [860000] },
		redirect: 'redPacket',
		children: [
			{
				path: 'redPacket',
				component: () => import('@/leniuview/accountCenter/redPacket'),
				name: '红包发放',
				id: 860100,
				meta: { title: '红包发放', roles: [860100] }
			},
			{
				path: 'distributionRecord',
				component: () => import('@/leniuview/accountCenter/redPacket/distributionRecord'),
				name: '发放记录',
				id: 860200,
				meta: { title: '发放记录', roles: [860200] }
			}
		]
	},
	{
		path: 'report',
		component: LayoutView,
		name: '账户汇总',
		id: 870000,
		meta: { title: '账户汇总', roles: [870000] },
		redirect: 'redPacket',
		children: [
			{
				path: 'changeFlow',
				component: () => import('@/leniuview/accountCenter/report/change-flow'),
				name: '账户流水表',
				id: 870100,
				meta: { title: '账户流水表', roles: [870100] }
			},
			{
				path: 'classify',
				component: () => import('@/leniuview/accountCenter/report/classify'),
				name: '分类汇总表',
				id: 870200,
				redirect: 'classify/person',
				meta: { title: '分类汇总表', roles: [870200] },
				children: [
					{
						path: 'person',
						component: () =>
							import('@/leniuview/accountCenter/report/classify/person'),
						name: '人员分类汇总',
						meta: { title: '人员分类汇总', roles: [870200], noCache: true },
						hidden: true
					},
					{
						path: 'type',
						component: () =>
							import('@/leniuview/accountCenter/report/classify/type'),
						name: '类别分类汇总',
						meta: { title: '类别分类汇总', roles: [870200], noCache: true },
						hidden: true
					},
					{
						path: 'org',
						component: () =>
							import('@/leniuview/accountCenter/report/classify/org'),
						name: '组织分类汇总',
						meta: { title: '组织分类汇总', roles: [870200], noCache: true },
						hidden: true
					}
				]
			},
			{
				path: 'cashier',
				component: () => import('@/leniuview/accountCenter/report/cashierSummary'),
				name: '操作员汇总表',
				id: 870300,
				meta: { title: '操作员汇总表', roles: [870300] }
			}
		]
	}
	]
}

export default accountRouter
